import React, { useEffect, useState } from 'react';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import CollectionSelect from '../../template/CollectionSelect';
import { Editor } from 'react-draft-wysiwyg';
import RestAPICollectionFieldsModal from '../rest-api/RestAPICollectionFieldsModal';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { dynamicSort } from '../../../common/utils/api_utils';
import showAlert from '../../../common/utils/alert';
import { CHAT_GPT, chatGptModels } from 'drapcode-constant';
import { ContentState, EditorState, Modifier } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { toast } from 'react-toastify';
import { FieldsSelect } from './FieldsSelect';

export const ChatGptForm = ({
  actions,
  projectId,
  version,
  externalApiId,
  externalApiData,
  externalapi,
  collections,
  iPlugins,
  history,
  projectDetail,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [externalApiName, setExternalApiName] = useState('');
  const [url, setUrl] = useState('https://api.openai.com/v1/chat/completions');
  const [nameError, setNameError] = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [model, setModel] = useState('');
  const [temperature, setTemperature] = useState(0);
  const [addFieldsModal, setAddFieldsModal] = useState(false);

  const collection = collections.find((coll) => coll.collectionName === collectionName);
  const chatGPTPluging =
    iPlugins && iPlugins.length > 0 ? iPlugins.find((plug) => plug.code === CHAT_GPT) : '';
  let tenantCollectionId = '';
  const multiTenantPlugin =
    iPlugins && iPlugins.length > 0 ? iPlugins.find((e) => e.code === 'MULTI_TENANT_SAAS') : '';
  if (multiTenantPlugin) tenantCollectionId = multiTenantPlugin.setting.multiTenantCollection;
  useEffect(() => {
    let model,
      temperature = '';

    if (chatGPTPluging && chatGPTPluging.setting) {
      model = chatGPTPluging.setting.model;
      temperature = chatGPTPluging.setting.temperature;
    }
    if (externalApiData) {
      setExternalApiName(externalApiData.externalApiName);
      setCollectionName(externalApiData.collectionName);
      if (externalApiData.setting) {
        const { content, model: apiModel, temperature: apiTemperature } = externalApiData.setting;
        model = apiModel ? apiModel : model;
        temperature = apiTemperature ? apiTemperature : temperature;
        if (content) {
          const blocksFromHtml = htmlToDraft(content);
          const { contentBlocks, entityMap } = blocksFromHtml;
          const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
          const editorState = EditorState.createWithContent(contentState);
          setEditorState(editorState);
        }
      }
    }
    setModel(model);
    setTemperature(temperature);
  }, [externalApiData]);

  const handleSelectChange = (name, value) => {
    if (collectionName) {
      const preConfirm = () => console.log('collectionName :>> ', value);
      showAlert(
        'Editor selected fields will be removed by this.',
        preConfirm,
        'Yes, change it!',
      ).then((result) => {
        if (result.isConfirmed) setCollectionName(value);
      });
    } else setCollectionName(value);
  };

  const isValidationError = () => {
    let isError = false;
    if (externalApiName === '' || !externalApiName) {
      setNameError('This field is required');
      isError = true;
    }
    if (externalApiName.length > 100) {
      setNameError('Name can not be more than 100 characters');
      isError = true;
    }
    if (nameError) {
      isError = true;
    }
    return isError;
  };

  const collectionsOptions = () => {
    const { collections } = externalapi;
    let options = [];
    if (collections) {
      options = options.concat(
        collections.sort(dynamicSort('collectionTitle')).map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const toggleAddFieldsModal = () => setAddFieldsModal(!addFieldsModal);

  const copyToClipboard = (toastMsg) => {
    toggleAddFieldsModal();
    toast.success(toastMsg);
  };

  const insertTextToParamInput = (textToInsert) => {
    if (textToInsert) {
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        textToInsert,
        editorState.getCurrentInlineStyle(),
      );
      setEditorState(EditorState.push(editorState, contentState, 'insert-characters'));
      copyToClipboard('Text Inserted');
    }
  };

  const historyBack = () => history.push(`/externalapi/${version}/v/${projectId}/chatGpt`);

  const handleSubmit = () => {
    if (isValidationError()) return;
    const content = editorState.getCurrentContent().getPlainText('\n');
    let data = {};
    data.collectionName = collectionName;
    data.projectId = projectId;
    data.version = version;
    data.externalApiName = externalApiName;
    data.externalApiType = CHAT_GPT;
    data.setting = {
      model,
      temperature,
      content,
      methodType: 'POST',
      url,
      headers: [],
      params: [],
    };

    if (externalApiId) {
      data.externalApiId = externalApiId;
      actions.updateExternalApi(data).then(() => historyBack());
    } else {
      actions.createExternalApi(data).then(() => historyBack());
    }
  };

  return (
    <>
      <div className="row pb-3">
        <div className="col-12 col-md-12 col-lg-12">
          <CustomInputWithIcon icon="text" title="Name">
            <input
              type="text"
              name="externalApiName"
              className="form-control form-control-sm"
              onChange={(e) => setExternalApiName(e.target.value)}
              value={externalApiName}
              placeholder="Name"
            />
            {nameError && <p className="errors">{nameError}</p>}
          </CustomInputWithIcon>
        </div>
        <div className="col-12 col-md-12 col-lg-12">
          <CustomInputWithIcon icon="url" title="URL">
            <input
              type="text"
              name="url"
              className="form-control form-control-sm"
              value={url}
              placeholder="External API URL"
            />
          </CustomInputWithIcon>
        </div>
        <div className="col-12 col-md-12 col-lg-12">
          <CollectionSelect
            options={collectionsOptions}
            value={collectionName}
            onChange={handleSelectChange}
          />
        </div>
        <div className="col-6 col-md-6 col-lg-6">
          <FieldsSelect
            name={'model'}
            title={'Model'}
            placeholder={'Model'}
            options={chatGptModels}
            value={model}
            onChange={(name, value) => setModel(value)}
          />
        </div>
        <div className="col-6 col-md-6 col-lg-6">
          <CustomInputWithIcon icon="number" title="Temperature">
            <input
              type="number"
              name="temperature"
              className="form-control form-control-sm"
              onChange={(e) => setTemperature(e.target.value)}
              value={temperature}
              placeholder="Temperature"
            />
          </CustomInputWithIcon>
        </div>
        <div className="col-12 col-md-12 col-lg-12">
          <Editor
            editorState={editorState}
            editorClassName="form-control mail-editor border-left-editor border-right-editor"
            wrapperClassName="form-group form-control h-auto no-bg-img"
            onEditorStateChange={(editorState) => setEditorState(editorState)}
            placeholder="Content"
            toolbar={{
              options: [],
            }}
            toolbarCustomButtons={[
              <>
                <RestAPICollectionFieldsModal
                  selectedCollection={collection}
                  collections={collections}
                  copyToClipboard={() => copyToClipboard('Copied to clipboard')}
                  insertTextToEditor={(textToInsert) =>
                    insertTextToParamInput(textToInsert, 'Text Inserted')
                  }
                  toggleFields={addFieldsModal}
                  toggleFieldsModal={toggleAddFieldsModal}
                  projectDetail={projectDetail}
                  tenantCollectionId={tenantCollectionId}
                />
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-theme-submit btn-xs btn-icon-only"
                    title="Add Fields"
                    onClick={toggleAddFieldsModal}
                  >
                    <i className="wb webconnect-plus" />
                  </button>
                </div>
              </>,
            ]}
          />
        </div>
      </div>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
        <button type="button" className="btn btn-default btn-md mr-2" onClick={historyBack}>
          <i className={`wb ${drapcodeIcon('back')}`}></i>&nbsp;Back
        </button>
        <button className="btn btn-theme-submit btn-md" onClick={handleSubmit}>
          <i className={`wb ${drapcodeIcon(externalApiId ? 'update' : 'save')}`}></i>
          &nbsp;{externalApiId ? 'Update' : 'Create'}&nbsp;
        </button>
      </div>
    </>
  );
};
